const ProfileNavData = [
    {
        title: "Profile",
        link: "/profile/setting"
    },
    {
        title: "Password",
        link: "/profile/change-password"
    },
    {
        title: "Logout",
        link: "/profile/logout"
    }
];

export default ProfileNavData;